import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

// components
import { Button } from 'components/shard'

// const
import { Size, Color } from 'const'

function PasswordSendmail() {
  const history = useHistory()

  return (
    <Wrapper>
      <Title>パスワード再発行メール送信</Title>
      <Message>パスワード再発行メール送信完了</Message>
      <ButtonWrapper>
        <Button
          type={'submit'}
          primary
          onClick={() => {
            history.push('/login')
          }}
        >
          ログイン画面へ
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 80px 100px 50px 50px 1fr;
`

const Title = styled.div`
  grid-row: 2;
  display: flex;
  align-items: flex-end;
  font-size: ${Size.FONT.HEADLINE.LEARGE};
  padding-bottom: 20px;
  border-bottom: 1px solid ${Color.LINE.NORMAL};
`

const Message = styled.div`
  grid-row: 3;
  padding: 8px 0;
  color: ${Color.FONT.ANNOTATION};
  padding-top: 30px;
`

const ButtonWrapper = styled.div`
  grid-row: 4;
  display: flex;
  justify-content: center;
  padding-top: 100px;
`

PasswordSendmail.propTypes = {
  values: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitLogin: PropTypes.func,
}

export default PasswordSendmail
